module.exports = __webpack_public_path__ + "img/speedometer-submenu.364eaad7.svg";